import React from "react";
import beautifulTree from "../../../Assets/beautifulTree.png";
import grassBg from "../../../Assets/grass2.png";
import ImageComponent from "../../Image/ImageComponent";

const TreeGuyPlatform = () => {
  return (
    <section className="relative w-full bg-[#f8f5f1]">
      {/* Semi-transparent overlay for opacity effect */}
      <div
        className="absolute inset-0 bg-[#f8f5f1] opacity-90"
        style={{
          zIndex: 1,
        }}
      ></div>

      {/* Content Container */}
      <div className="container mx-auto px-4 flex flex-col lg:flex-row items-center relative z-10 gap-12 pt-7">
        {/* Left Image Section */}
        <div className="w-full lg:w-1/2 flex justify-center mb-8 lg:mb-0">
          <ImageComponent
            src={beautifulTree}
            alt="Beautiful tree"
            className="shadow-lg"
          />
        </div>

        {/* Right Text Section */}
        <div className="w-full lg:w-1/2 text-center lg:text-left">
          <h2 className="heading text-[#0b3d2c]">
            YOUR TREE GUY PLATFORM
          </h2>
          <p className="text-[#777777] text-sm md:text-lg leading-relaxed">
            Introducing YourTreeGuy: the platform revolutionizing the tree care
            industry for property owners and arborists alike. Our advanced
            AI-driven tools are your gateway to expert advice, precise
            identification of tree species and diseases, and real-time, dynamic
            pricing for arborist services. Not only does YourTreeGuy make tree
            care straightforward and accessible for property managers and
            homeowners, but it also empowers arborists with smart tools to
            enhance their efficiency and expand their customer base. Connect
            instantly with certified arborists in your area, and experience the
            future of tree care where innovation, and your trees, will thrive.
          </p>
        </div>
      </div>

      {/* Grass Background Image */}
      <div className="relative bottom-0 w-full">
        <ImageComponent
          src={grassBg}
          alt="Grass background"
          className="md:h-28 md:w-full"
        />
      </div>
    </section>
  );
};

export default TreeGuyPlatform;
